import { exitToMenu } from '../../../formSections/utils';
import { onLink } from '../../../handlers';

export const getBackLink = (stateProps, formikProps) => {
  const sectionName = stateProps.sectionData.sectionName;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const resume = stateProps.dataToSave.saved.resumes[resumeIndex];
  let backLink = 'menu';
  if(resume.industry === undefined) {
    return null;
  } else {
    const industryName = resume.industry !== undefined ? resume.industry[0] : '';

    /*if (rawIndustryName) {
      if (typeof stateProps.dataToSave.industry[rawIndustryName] !== 'undefined') {
        industryName = stateProps.dataToSave.industry[rawIndustryName].label;
      } else {
        industryName = rawIndustryName;
      }
    }*/
    const jobTitleRaw = stateProps.dataToSave.saved.resumes[resumeIndex].job_title;
    const jobParts = typeof jobTitleRaw !== 'undefined' ? jobTitleRaw.split(' ') : [];
    let jobTitle = '';
    for (const jobPartRaw of jobParts) {
      jobTitle += jobPartRaw.charAt(0).toUpperCase() + jobPartRaw.slice(1) + ' ';
    }
    jobTitle = jobTitle.trim();
    let backLinkLabel = jobTitle + '/' + industryName.charAt(0).toUpperCase() + industryName.slice(1) + ' Resume Content';
    let backClick = () => exitToMenu({ stateProps, formikProps });
    if (sectionName === 'menu' || sectionName === 'parser') {
      backLink = 'resumes';
      backLinkLabel = 'My Resumes';
      backClick = () => onLink(false, formikProps, stateProps, backLink, false);
    }
    const showBackLink = sectionName === 'resumes' ? false : true;
    return [backClick, backLinkLabel, showBackLink];
  }
};

export const getResumeName = (stateProps) => {
  const resumeIndex = stateProps.sectionData.resumeIndex;
  let resumeName = '';
  if (typeof stateProps.dataToSave.saved.resumes[resumeIndex] !== 'undefined') {
    const curResume = stateProps.dataToSave.saved.resumes[resumeIndex];
    if (typeof curResume.job_title !== 'undefined') {
      resumeName = 'RESUME: ' + curResume.job_title;
    }
  }
  return resumeName;
};
